module.exports = __webpack_public_path__ + "img/template2.9332af79.png";